import { useEffect } from 'react';
import styles from './GameStartOverlay.module.css';

export interface GameStartOverlayProps {
  youGoFirst: boolean;
  opponentNickname: string;
  opponentAvatar: string;
  onDismiss: () => void;
}

function getAvatarSrc(name: string): string {
  const file = name.toLowerCase().replace(/\s+/g, '-');
  return `/avatars/${file}.svg`;
}

export function GameStartOverlay({
  youGoFirst,
  opponentNickname,
  opponentAvatar,
  onDismiss,
}: GameStartOverlayProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div className={styles.overlay} role="alert" aria-live="assertive">
      {!youGoFirst && (
        <img
          src={getAvatarSrc(opponentAvatar)}
          alt={`${opponentNickname}'s avatar`}
          className={styles.avatar}
        />
      )}
      <span className={styles.message}>
        {youGoFirst
          ? 'You go first! 🍄'
          : `${opponentNickname} goes first — get ready!`}
      </span>
    </div>
  );
}
